import { useEffect, useState } from "react";
import plus from "../../Media/plus-line-icon.svg";

const Accordion = (props) => {
  const itemTitleHeight = 70;
  const maxBody = (props.height - (itemTitleHeight*2))


  const [activeItem, setActiveItem] = useState(1);
  const expandHandler = (index) => {
    if (!activeItem) {
      setActiveItem(index);
      setIconRotation(index)
    }
    if (activeItem) {
      if (activeItem === index) {
        setActiveItem(null);
        document.querySelectorAll(".plus-icon").forEach((icon) => {icon.style.transform = "rotate(0deg)"})
      }
      if (activeItem !== index) {
        setActiveItem(index);
        setIconRotation(index)
      }
    }
  };
  useEffect(() => {setIconRotation(activeItem)},[])

  const setIconRotation = (index) => {
    document.querySelectorAll(".plus-icon").forEach((icon) => {
      if (icon.dataset.index == index) {
        icon.style.transform = "rotate(45deg)";
      } else {
        icon.style.transform = "rotate(0deg)";
      }
    });
  };

  const displayFunction = (index) => {
    return index === activeItem ? "flex" : "none";
  };
  return (
    <div id="accordion">
      {props.dataForAccordion.map((singleItem, index) => {
        return (
          <div
            key={index}
            className="accordionItem"
            data-index={index + 1}
          >
            <div
              className="accordionItemTitle"
              data-index={index + 1}
              onClick={() => expandHandler(index + 1)}
              style={{height:itemTitleHeight}}
            >
              <img
                data-index={index + 1}
                className="plus-icon"
                width={15}
                src={plus}
              />
              <p>{singleItem.title}</p>
            </div>
            <div
              className="accordionItemBody"
              style={{ display: displayFunction(index + 1), height: maxBody  }}
              data-index={index + 1}
            >
              <img style={{}} src={singleItem.body}></img>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;
